// ##### Komarov 2025-07-30
import uniqueId from 'lodash.uniqueid';
import Col from 'react-bootstrap/Col';
import { useDispatch, useSelector } from 'react-redux';
// ##### Komarov 2025-07-12
import React, { useEffect } from 'react';
// ##### Komarov 2025-07-31
import { getAutocompleteData, setSearchHotelsLinks, setSitePageListSection } from '../../../Redux/actions';
// ##### Komarov 2025-07-24
import moment from 'moment';
import { isEmptyObject } from '../../../../server/helpers/isArrayObject';
import { uniLog } from '../../../../server/helpers/uniLog';
import { encryptString } from '../../../helpers/crypto';
import dateFormats from '../../../helpers/dateFormats';
import LocalizationNavLink from '../../Library/Localization/LocalizationNavLink';
import { makeParamsString, ValidateQuery } from '../Helpers/helper';
import { formFooterColumns, getSitePageListSection } from './helpers';
import { DataId } from '../../../Redux/helpers/withSmartDataId';

// ##### Komarov 2025-07-14
const PagesLinks = () => {
  const pickedcurrency = useSelector(state => state.currency.pickedcurrency);

  const companyCipher = useSelector(state => state.whitelabel.company_cipher);
  // ##### 25-03-20 Komarov
  const language = useSelector(state => state.language);
  const cities = useSelector(state => state.cities);

  // ##### 24-09-09 Komarov
  const countryLocalized = useSelector(state => state.country)[language];
  // ##### 25-03-20 Komarov
  const cities_overview_top = useSelector(
    state => state.cities.cities_overview_top
  );
  const occupied_cities_top = useSelector(
    state => state.cities.occupied_cities_top
  );
  const attractions_top = useSelector(state => state.cities.attractions_top);
  const hotels_overview_top = useSelector(
    state => state.hotels.hotels_overview_top
  );
  const autocomplete_data = useSelector(
    state => state.hotels.autocomplete_data[language]
  );
  // ##### 25-03-26 Komarov
  const pages = useSelector(state => state.pages.pages);
  const isWhiteLabelSet = useSelector(state => state.whitelabel.set);
  const dispatch = useDispatch();

  // ##### Komarov 2025-07-12
  useEffect(() => {
    dispatch(
      setSitePageListSection(getSitePageListSection(pages, isWhiteLabelSet))
    );
  }, []);

  // ##### Komarov 2025-08-05
  const autocomplete_data_loaded = useSelector(
    state => state.hotels.autocomplete_data_loaded[language]
  );

  // ##### Komarov 2025-09-11
  const sale = useSelector(state => state.company.sale_id);
  const promocode = useSelector(state => state.promocode.promocode);
  const { user: currentUser } = useSelector(state => state.auth);
  const company_id = useSelector(state => state.auth.user.company_id);
  // ##### Komarov 2025-07-12
  useEffect(() => {
    if (autocomplete_data_loaded) {
      return;
    }
    // ##### 25-04-30 Komarov
    uniLog(
      'axios:src/Components/Pages/FirstPageofSearchModule/HotelsAutocompleteBlock/HotelsAutocomplete.js:getAutocompleteData'
    );
    // ##### 25-03-12 Komarov
    dispatch(
      getAutocompleteData({
        // ##### Komarov 2025-05-26
        sale_id: sale || null,
        promocode,
        user_id: currentUser.user_id,
        refpartner: company_id,
        language,
      })
    );
    // ##### 25-03-26 Komarov
  }, [autocomplete_data_loaded, language]);

  // ##### 25-03-13 Komarov
  const localeUpper = language.toUpperCase();

  // Cl-Srv: Переменная, заменяющая action getSitePageRegion (файлы src/Components/Pages/PageComponents/ContentPages.js и src/Redux/actions/pages.js), логику взял из упомянутого action
  const sitePageRegionsList = pages
    .filter((item, index, array) => {
      if (item.sitepage_region_id !== null) {
        return (
          array.findIndex(
            t =>
              parseInt(t.sitepage_region_id) ===
              parseInt(item.sitepage_region_id)
          ) === index
        );
      }
    })
    .map(item1 => {
      return {
        // ##### 24-03-21 Komarov
        sitepage_region_id: item1.sitepage_region_id,
        sitepage_region_name: item1.sitepage_region_name,
      };
    });

  // ##### Komarov 2025-08-02
  const searchHotelsLinks = useSelector(state => state.searchHotelsLinks);

  // ##### 25-03-26 Komarov
  const footerColumns = formFooterColumns(
    pages,
    isWhiteLabelSet,
    sitePageRegionsList,
    autocomplete_data,
    cities,
    cities_overview_top,
    occupied_cities_top,
    attractions_top,
    hotels_overview_top,
    localeUpper,
    language
  );

  const shouldCypherUrlParams = useSelector(
    state => state.siteCypherCodeData.isDataEncrypted
  );
  const cypherKey = useSelector(
    state => state.siteCypherCodeData.description
  );

  const validateQuery = (url) => {
    if (url) {
      return ValidateQuery(
        url,
        shouldCypherUrlParams,
        cypherKey
      );
    }
    // ##### Komarov 2025-07-21
    const validatedQuery = ValidateQuery(
      location,
      shouldCypherUrlParams,
      cypherKey
    );
    return (!isEmptyObject(validatedQuery) && validatedQuery) || undefined;
  };

  const getSearchHotelsLink = (params) => {
    const params_string = makeParamsString(params);
    const basePath = isWhiteLabelSet ? `/ref${companyCipher}/search_results_hotels/` : '/search_results_hotels/';
    const queryString = shouldCypherUrlParams ? encryptString(params_string) : params_string;
    const linkString = `${basePath}?${queryString}`;
    return linkString;
  };

  useEffect(() => {
    // ##### Komarov 2025-09-09
    if (searchHotelsLinks[language]?.[pickedcurrency]) return;
    let citiesIds = [];
    for (const lang in searchHotelsLinks) {
      for (const currency in searchHotelsLinks[lang]) {
        if (currency) {
          citiesIds = Object.keys(searchHotelsLinks[lang][currency]);
        }
      }
    }
    let searchHotelsLinksForCurrency = {};
    for (const id of citiesIds) {
      const params = {
        selected_currency: pickedcurrency,
        // ##### Komarov 2025-08-15
        title: autocomplete_data.data?.data.list[`${id}:0`].title,
        start: moment().add(1, 'days').format(dateFormats.en),
        end: moment().add(2, 'days').format(dateFormats.en),
        id: 0, // hotel's id
        city_id: id,
        adults: 1,
        children: 0,
        rooms: 1,
      };
      const search_hotels_link = getSearchHotelsLink(params);
      searchHotelsLinksForCurrency[id] = search_hotels_link;
    }
    // ##### Komarov 2025-09-09
    if (!searchHotelsLinks[language]) {
      searchHotelsLinks[language] = {};
    }
    searchHotelsLinks[language][pickedcurrency] = searchHotelsLinksForCurrency;
    dispatch(setSearchHotelsLinks(searchHotelsLinks));
  }, [pickedcurrency, language]);

  return (
    <>
      {Object.keys(footerColumns)?.map(footerColumnName => {
        // ##### 26-06-30 Komarov
        const columnTitle = footerColumns[footerColumnName].title?.[0]?.text;
        const columnPages = footerColumns[footerColumnName]?.itemList ?? [];
        switch (footerColumnName) {
          case 'INFORMATION':
            return (
              <Col lg={true} key={uniqueId()}>
                <div className="footerLinks">
                  <h3>{columnTitle}</h3>
                  <ul>
                    {columnPages.map(page => (
                      <li key={uniqueId()}>
                        <h2>
                          { /* ##### Komarov 2025-07-24 */}
                          <LocalizationNavLink
                            // ##### 25-04-21 Komarov
                            to={(isWhiteLabelSet &&
                              `/ref${companyCipher}/sitepages/?name=${page.name
                                .replace(/\s/g, '-')
                                .toLowerCase()}&spid=${page.id}`) ||
                              `/sitepages/?name=${page.name
                                .replace(/\s/g, '-')
                                .toLowerCase()}&spid=${page.id}`}
                            activeClassName=""
                          >
                            {/* ##### 26-06-30 Komarov */}
{page.title?.[0]?.text ?? page.name}
                            </LocalizationNavLink>
                          </h2>
                        </li>
                      ))}
                    </ul>
                  </div>
                </Col>
              );

            case 'CITY HOTELS':
              return (
                <Col lg={true} key={uniqueId()}>
                  <div className="footerLinks">
                    <h3>{columnTitle}</h3>
                    <ul>
                      {columnPages.map(page => {
                        // ##### Komarov 2025-09-09
                        const city_id = cities.cities.find(
                          item => item.name === page.name.split(' ', 1)[0]
                        ).id;
                        return (
                          <li key={uniqueId()}>
                            <h2>
                              {searchHotelsLinks[language]?.[pickedcurrency] && searchHotelsLinks[language][pickedcurrency][city_id] ? <LocalizationNavLink
                                to={searchHotelsLinks[language][pickedcurrency][city_id]}
                              >
                                {page.title?.[0]?.text ?? page.name}
                            </LocalizationNavLink> : <span>{page.title?.[0]?.text ?? page.name}</span>}
                          </h2>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </Col>
            );

          case 'ATTRACTIONS':
            return (
              <DataId smartId="GET_ATTRACTIONS_TOP_RES" as={Col} lg={true} key={uniqueId()}>
                <div className="footerLinks">
                  <h3>{columnTitle}</h3>
                  <ul>
                    {columnPages.map(page => (
                      <li key={uniqueId()}>
                        <h2>
                          {/* ##### 24-08-16 Komarov */}
                          <LocalizationNavLink
                            // ##### 25-04-21 Komarov
                            to={`/city_overview/?name=${page.object_name
                              .replace(/\s/g, '-')
                              .toLowerCase()}&spid=${page.sitepageobject_id}&sptid=${page.type_id
                              }`}
                            activeClassName=""
                          >
                            {/* ##### 24-09-11 Komarov */}
                            {page.object_langname}
                            {page.object_name !== 'Others' &&
                              `, ${countryLocalized}`}
                          </LocalizationNavLink>
                        </h2>
                      </li>
                    ))}
                  </ul>
                </div>
              </DataId>
            );

          case 'CITIES Overview':
            return (
              <DataId smartId="GET_CITIES_OVERVIEW_TOP_RES" as={Col} lg={true} key={uniqueId()}>
                <div className="footerLinks">
                  <h3>{columnTitle}</h3>
                  <ul>
                    {columnPages.map(page => {
                      return (
                        <li key={uniqueId()}>
                          <h2>
                            <LocalizationNavLink
                              to={`/city_overview/?name=${page.object_name
                                .toLowerCase()
                                .replace(/\s/g, '-')
                                .toLowerCase()}&spid=${page.sitepageobject_id}&sptid=${page.type_id
                                }`}
                              activeClassName=""
                            >
                              {/* ##### 24-09-11 Komarov */}
                              {page.object_langname}
                              {page.object_name !== 'Others' &&
                                `, ${countryLocalized}`}
                            </LocalizationNavLink>
                          </h2>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </DataId>
            );

          // ##### 24-09-05 Komarov
          case 'Occupied CITIES':
            return (
              <DataId smartId="GET_OCCUPIED_CITIES_TOP_RES" as={Col} lg={true} key={uniqueId()}>
                <div className="footerLinks">
                  <h3>{columnTitle}</h3>
                  <ul>
                    {columnPages.map(page => {
                      return (
                        <li key={uniqueId()}>
                          <h2>
                            <LocalizationNavLink
                              to={`/city_overview/?name=${page.object_name
                                .toLowerCase()
                                .replace(/\s/g, '-')
                                .toLowerCase()}&spid=${page.sitepageobject_id}&sptid=${page.type_id
                                }`}
                              activeClassName=""
                            >
                              {/* ##### 24-09-11 Komarov */}
                              {page.object_langname}
                              {page.object_name !== 'Others' &&
                                `, ${countryLocalized}`}
                            </LocalizationNavLink>
                          </h2>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </DataId>
            );

          // ##### 24-07-31 Komarov
          case 'HOTELS Overview':
            return (
              <DataId smartId="GET_HOTELS_OVERVIEW_TOP_RES" as={Col} lg={true} key={uniqueId()}>
                <div className="footerLinks">
                  <h3>{columnTitle}</h3>
                  <ul>
                    {columnPages.map(page => {
                      return (
                        <li key={uniqueId()}>
                          <h2>
                            {/* ##### 24-08-05 Komarov */}
                            {page.object_name === 'Others' ? (
                              <LocalizationNavLink
                                // ##### 24-08-23 Komarov
                                to={`/city_overview/?name=${page.object_name
                                  .toLowerCase()
                                  .replace(/\s/g, '-')
                                  .toLowerCase()}&spid=${page.sitepageobject_id}&sptid=${page.type_id
                                  }`}
                                activeClassName=""
                              >
                                {page.object_langname}
                              </LocalizationNavLink>
                            ) : (
                              <LocalizationNavLink
                                // ##### 25-04-21 Komarov
                                to={`/hotel_overview/?id=${page.object_id}&city_id=${page.city_id}&hotel_name=${page.object_name.toLowerCase().replace(/\s/g, '-').toLowerCase()}`}
                                activeClassName=""
                              >
                                {page.object_langname}
                              </LocalizationNavLink>
                            )}
                          </h2>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </DataId>
            );

          default:
            return <>Unexpected {footerColumnName}</>;
        }
      })}
    </>
  );
};

export default PagesLinks;
